<div
  class="d-flex menu-item"
  (click)="openRequestForDemo()">
  <a
    class="font-weight-bold w-100"
    [attr.title]="'header.schedule-demo' | transloco">
    <button
      class="new-sh-button w-100"
      data-cy="main-nav-request-demo-schedule-demo"
      color="accent"
      mat-stroked-button>
      {{ 'header.schedule-demo' | transloco }}
    </button>
  </a>
</div>
